import type { NavigationGuardWithThis } from 'vue-router'
import { initializeKeycloak } from '@/composables/stammdatenApiComposable'
import { useEnv } from '@/composables/enviromentComposable'

export const keycloakBeforeEnter: NavigationGuardWithThis<undefined> = async (to, from, next) => {
  const env = useEnv()

  if (env.AUTH_DISABLED) {
    next()
    return
  }

  await initializeKeycloak(`${env.KEYCLOAK_REDIRECT_URI}${to.path}`)
  next()
}
